import { Button } from '@mantine/core';
import { ChevronsDown, ChevronsUp } from 'lucide-react';
import { useState } from 'react';

import TaskCard from '@/components/TaskView/TaskCard.tsx';

import { usePatientTasks } from '@/hooks/use-patient-tasks.ts';

import { GenericPatient } from '@/models/GenericPatient.ts';
import { TaskModalMode } from '@/models/TaskModalMode.ts';
import { EnrichedTask } from '@/models/doc-cirrus/DCTask.ts';

import { useTaskViewStore } from '@/stores/taskViewStore.ts';

import { openTaskModal } from '@/utils/task-utils.tsx';

interface Props {
    patient: GenericPatient;
}

const PATIENT_TASKS_PREVIEW_LIMIT = 3;

export const PatientTasks = ({ patient }: Props) => {
    const { tasks } = usePatientTasks(patient);
    const [isExpanded, setIsExpanded] = useState(false);

    const handleTaskClick = (task: EnrichedTask): void => {
        useTaskViewStore.setState({ task_list: tasks });
        openTaskModal({ task: task, mode: TaskModalMode.DETAILS });
    };

    const handleToggleExpanded = (): void => {
        setIsExpanded((previous) => !previous);
    };

    if (tasks.length === 0) return undefined;

    const hasMore = tasks.length > PATIENT_TASKS_PREVIEW_LIMIT;
    const visibleTasks = isExpanded ? tasks : tasks.slice(0, PATIENT_TASKS_PREVIEW_LIMIT);

    return (
        <div className="flex flex-col gap-2">
            {visibleTasks.map((task) => (
                <TaskCard
                    key={`${task.instance_id}-${task.id}`}
                    task={task}
                    onClick={handleTaskClick}
                    showLocationAndAssignee
                    compact
                />
            ))}
            {hasMore && (
                <Button
                    leftSection={isExpanded ? <ChevronsUp className="size-4" /> : <ChevronsDown className="size-4" />}
                    onClick={handleToggleExpanded}
                    variant="transparent"
                    className="self-center text-slate-500 hover:text-black"
                >
                    {isExpanded ? 'Weniger anzeigen' : `Mehr anzeigen (${tasks.length - PATIENT_TASKS_PREVIEW_LIMIT})`}
                </Button>
            )}
        </div>
    );
};
